/**
 * Beardbrand Secondary Add to Cart -Jenny updated 9/21/26
 * - Proxies the real primary PDP ATC so existing Recharge/cart behavior stays intact.
 * - Quantity mode defaults to matching the primary Buy Buttons quantity setting, with optional Always show / Always hide overrides from plus-secondary-atc.liquid.
 * - When both quantity selectors exist they stay synchronized.
 * - If only the secondary selector is shown, its value is passed to the real
 *   Shopify product form through a temporary hidden quantity input.
 */

window.Plus = window.Plus || {};

Plus.SecondaryAddToCart = {
  init: init,
  makeSticky: makeSticky
};

document.addEventListener('DOMContentLoaded', function() {
  Plus.SecondaryAddToCart.init();
  Plus.SecondaryAddToCart.makeSticky();
});

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    Plus.SecondaryAddToCart.init();
    Plus.SecondaryAddToCart.makeSticky();
  });
}


/**
 * Secondary Add to Cart
 */
function init() {
  const secondaryAtcSection =
    document.querySelector('.secondary-atc-section');

  const secondaryAtcButton =
    secondaryAtcSection?.querySelector('.secondary-atc-button');

  const primaryProductForm =
    document.querySelector(
      'product-page product-form.product--add-to-cart-form'
    );

  const primaryAtcButton =
    primaryProductForm?.querySelector(
      'button[name="add"].product__add-to-cart'
    );

  if (
    !secondaryAtcSection ||
    !secondaryAtcButton ||
    !primaryProductForm ||
    !primaryAtcButton
  ) {
    return;
  }

  /*
   * Resolve whether the secondary quantity selector should display:
   * - inherit: match the primary Buy Buttons quantity setting
   * - show: always show
   * - hide: always hide
   */
  updateSecondaryQuantityState();

  /*
   * Quantity listeners are delegated so they continue to work after
   * Shopify section reloads in the Theme Editor.
   */
  bindQuantitySync();

  /*
   * Re-evaluate quantity state after the main product section reloads
   * or the current variant changes.
   */
  bindVariantQuantityRefresh();

  /*
   * Prevent duplicate ATC listeners if Shopify reloads this section.
   */
  if (secondaryAtcButton.dataset.plusSecondaryAtcBound === 'true') {
    return;
  }

  secondaryAtcButton.addEventListener('click', function(event) {
    event.preventDefault();

    // Prevent repeated clicks while the cart action is processing.
    if (secondaryAtcButton.classList.contains('working')) {
      return;
    }

    // Do nothing if the currently selected variant is unavailable.
    if (
      primaryAtcButton.classList.contains('disabled') ||
      primaryAtcButton.disabled ||
      primaryAtcButton.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    /*
     * If a visible secondary quantity selector is being used, sync that
     * value to the real primary quantity field or its hidden form proxy.
     * If the secondary quantity is hidden, leave the primary form alone.
     */
    syncSecondaryQuantityToPrimary();

    secondaryAtcButton.classList.add('working');

    /*
     * Trigger the real Beardbrand PDP button so Recharge and the existing
     * cart behavior remain the source of truth.
     */
    primaryAtcButton.click();

    // Visual working-state fallback.
    setTimeout(function() {
      secondaryAtcButton.classList.remove('working');
    }, 1500);
  });

  secondaryAtcButton.dataset.plusSecondaryAtcBound = 'true';
}


/**
 * Resolve the section's quantity display mode.
 */
function updateSecondaryQuantityState() {
  const secondaryAtcSection =
    document.querySelector('.secondary-atc-section');

  if (!secondaryAtcSection) {
    return;
  }

  const mode =
    secondaryAtcSection.dataset.quantitySelectorMode || 'inherit';

  const primaryQuantity =
    document.querySelector(
      'product-page product-form.product--add-to-cart-form .primary-quantity-selector'
    );

  const secondaryQuantity =
    secondaryAtcSection.querySelector('.secondary-quantity-selector');

  let showSecondaryQuantity = false;

  if (mode === 'show') {
    showSecondaryQuantity = Boolean(secondaryQuantity);
  } else if (mode === 'hide') {
    showSecondaryQuantity = false;
  } else {
    // Default behavior: match the primary Buy Buttons setting.
    showSecondaryQuantity =
      Boolean(primaryQuantity && secondaryQuantity);
  }

  secondaryAtcSection.classList.toggle(
    'secondary-atc-section--has-quantity',
    showSecondaryQuantity
  );

  if (!showSecondaryQuantity) {
    removeSecondaryQuantityProxy();
    return;
  }

  /*
   * When both selectors exist, initialize the secondary value from
   * the real primary quantity.
   */
  if (primaryQuantity) {
    removeSecondaryQuantityProxy();
    syncPrimaryQuantityToSecondary();
  }
}


/**
 * Refresh quantity state on variant changes.
 */
function bindVariantQuantityRefresh() {
  const productVariants =
    document.querySelector('product-page product-variants');

  if (
    !productVariants ||
    productVariants.dataset.plusSecondaryQuantityBound === 'true'
  ) {
    return;
  }

  productVariants.addEventListener('VARIANT_CHANGE', function() {
    updateSecondaryQuantityState();
    syncPrimaryQuantityToSecondary();
  });

  productVariants.dataset.plusSecondaryQuantityBound = 'true';
}


/**
 * Quantity synchronization.
 */
let quantitySyncBound = false;

function bindQuantitySync() {
  if (quantitySyncBound) {
    return;
  }

  /*
   * Manual typing in either quantity field.
   */
  document.addEventListener('input', function(event) {
    if (event.target.closest('.primary-quantity-selector')) {
      syncPrimaryQuantityToSecondary();
    }

    if (event.target.closest('.secondary-quantity-selector')) {
      syncSecondaryQuantityToPrimary();
    }
  });

  /*
   * The theme's ProductQuantity component handles the actual +/- change.
   * This delegated listener runs afterward and mirrors the resulting value.
   */
  document.addEventListener('click', function(event) {
    const quantityButton =
      event.target.closest('.qty-button');

    if (!quantityButton) {
      return;
    }

    if (quantityButton.closest('.primary-quantity-selector')) {
      syncPrimaryQuantityToSecondary();
    }

    if (quantityButton.closest('.secondary-quantity-selector')) {
      syncSecondaryQuantityToPrimary();
    }
  });

  quantitySyncBound = true;
}


/**
 * Copy the real primary quantity into the visible secondary selector.
 */
function syncPrimaryQuantityToSecondary() {
  const secondaryAtcSection =
    document.querySelector('.secondary-atc-section');

  if (
    !secondaryAtcSection ||
    !secondaryAtcSection.classList.contains(
      'secondary-atc-section--has-quantity'
    )
  ) {
    return;
  }

  const primaryInput =
    getPrimaryQuantityInput();

  const secondaryInput =
    getSecondaryQuantityInput();

  if (!primaryInput || !secondaryInput) {
    return;
  }

  setQuantityValue(
    secondaryInput,
    getValidQuantity(primaryInput)
  );
}


/**
 * Copy the visible secondary quantity into the real primary quantity.
 *
 * If the primary Buy Buttons quantity selector is disabled, create a
 * hidden quantity input inside the real Shopify product form instead.
 */
function syncSecondaryQuantityToPrimary() {
  const secondaryAtcSection =
    document.querySelector('.secondary-atc-section');

  if (
    !secondaryAtcSection ||
    !secondaryAtcSection.classList.contains(
      'secondary-atc-section--has-quantity'
    )
  ) {
    removeSecondaryQuantityProxy();
    return;
  }

  const secondaryInput =
    getSecondaryQuantityInput();

  if (!secondaryInput) {
    removeSecondaryQuantityProxy();
    return;
  }

  const value =
    getValidQuantity(secondaryInput);

  const primaryInput =
    getPrimaryQuantityInput();

  if (primaryInput) {
    removeSecondaryQuantityProxy();

    setQuantityValue(
      primaryInput,
      value
    );

    return;
  }

  setSecondaryQuantityProxy(value);
}


function getPrimaryQuantityInput() {
  return document.querySelector(
    'product-page product-form.product--add-to-cart-form .primary-quantity-selector input[type="number"]'
  );
}


function getSecondaryQuantityInput() {
  return document.querySelector(
    '.secondary-atc-section.secondary-atc-section--has-quantity .secondary-quantity-selector input[type="number"]'
  );
}


/**
 * If the primary quantity UI is absent, pass the visible secondary
 * quantity to Shopify using a hidden field in the real product form.
 */
function setSecondaryQuantityProxy(value) {
  const primaryForm =
    document.querySelector(
      'product-page product-form.product--add-to-cart-form form[data-type="add-to-cart-form"]'
    );

  if (!primaryForm) {
    return;
  }

  let quantityProxy =
    primaryForm.querySelector(
      'input[data-secondary-quantity-proxy]'
    );

  if (!quantityProxy) {
    quantityProxy = document.createElement('input');
    quantityProxy.type = 'hidden';
    quantityProxy.name = 'quantity';
    quantityProxy.setAttribute(
      'data-secondary-quantity-proxy',
      ''
    );

    primaryForm.appendChild(quantityProxy);
  }

  quantityProxy.value = value;
}


function removeSecondaryQuantityProxy() {
  const quantityProxy =
    document.querySelector(
      'product-page product-form.product--add-to-cart-form input[data-secondary-quantity-proxy]'
    );

  if (quantityProxy) {
    quantityProxy.remove();
  }
}


/**
 * Keep manually entered quantities within the input's allowed range.
 */
function getValidQuantity(input) {
  const min =
    input.min !== '' ? parseInt(input.min, 10) : 1;

  const max =
    input.max !== '' ? parseInt(input.max, 10) : 999;

  let value =
    parseInt(input.value, 10);

  if (Number.isNaN(value)) {
    value = min;
  }

  return Math.min(
    Math.max(value, min),
    max
  );
}


/**
 * Update an input plus the visual disabled states of its +/- buttons.
 */
function setQuantityValue(input, value) {
  input.value = value;

  const container =
    input.closest('product-quantity');

  if (!container) {
    return;
  }

  const minus =
    container.querySelector('.qty-minus');

  const plus =
    container.querySelector('.qty-plus');

  const min =
    input.min !== '' ? parseInt(input.min, 10) : 1;

  const max =
    input.max !== '' ? parseInt(input.max, 10) : 999;

  if (minus) {
    minus.classList.toggle(
      'disabled',
      value <= min
    );
  }

  if (plus) {
    plus.classList.toggle(
      'disabled',
      value >= max
    );
  }
}


/**
 * Sticky Secondary ATC
 */
function makeSticky() {
  const secondaryAtcContainer =
    document.querySelector('.secondary-atc');

  const secondaryAtcInner =
    document.querySelector('.secondary-atc-section');

  const primaryAtcButton =
    document.querySelector(
      'product-page product-form.product--add-to-cart-form button[name="add"].product__add-to-cart'
    );

  if (
    !secondaryAtcContainer ||
    !secondaryAtcInner ||
    !primaryAtcButton
  ) {
    return;
  }

  if (
    secondaryAtcInner.classList.contains(
      'secondary-atc-section-position--static'
    )
  ) {
    return;
  }

  secondaryAtcContainer.classList.add('fixed');

  // Prevent duplicate scroll listeners in Shopify Theme Editor.
  if (secondaryAtcContainer.dataset.plusStickyBound === 'true') {
    return;
  }

  function updateSecondaryAtcPosition() {
    const referencePosition =
      primaryAtcButton.getBoundingClientRect().bottom;

    if (referencePosition < 0) {
      secondaryAtcContainer.classList.remove('fixed--is-closed');
      secondaryAtcContainer.classList.add('fixed--is-open');
    } else {
      secondaryAtcContainer.classList.remove('fixed--is-open');
      secondaryAtcContainer.classList.add('fixed--is-closed');
    }
  }

  window.addEventListener(
    'scroll',
    updateSecondaryAtcPosition,
    { passive: true }
  );

  secondaryAtcContainer.dataset.plusStickyBound = 'true';

  updateSecondaryAtcPosition();
}